import axios from "axios";
import Config from "../utils/Config";

/**
 * Consumer-facing quote request API.
 * Endpoints: submit quote request, list my requests, get single request.
 */
class QuoteService {
  getAuthHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
  }

  /**
   * Create (submit) a new quote request.
   * @param {Object} payload - { policy_slug, coverage_duration_index, package_key, form_data }
   *   - package_key: full package object as JSON string (snapshot at request time)
   */
  async submitQuoteRequest(payload) {
    try {
      const response = await axios.post(
        `${Config.apiUrl}/user/quote/create`,
        payload,
        this.getAuthHeaders()
      );
      const resData = response.data?.data ?? response.data;
      return {
        status: true,
        message: resData?.reason ?? resData?.message ?? response.data?.message ?? "Quote request submitted successfully",
        data: resData,
      };
    } catch (error) {
      const errData = error.response?.data?.data ?? error.response?.data;
      return {
        status: false,
        message: errData?.reason ?? errData?.message ?? error.response?.data?.message ?? "Failed to submit quote request",
        data: null,
      };
    }
  }

  /** Get all quote requests for the logged-in user */
  async getMyQuoteRequests() {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/user/quote/requests`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data?.data ?? response.data?.data?.data ?? [],
        message: response.data?.message || "Quote requests fetched",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to fetch quote requests",
      };
    }
  }

  /** Get a single quote request by id */
  async getQuoteRequest(id) {
    try {
      const response = await axios.get(
        `${Config.apiUrl}/user/quote/requests/${id}`,
        this.getAuthHeaders()
      );
      return {
        status: true,
        data: response.data?.data ?? response.data?.data?.data,
        message: response.data?.message || "Quote request fetched",
      };
    } catch (error) {
      return {
        status: false,
        data: null,
        message: error.response?.data?.data?.reason || "Failed to fetch quote request",
      };
    }
  }
}

const quoteService = new QuoteService();
export default quoteService;
